<template>
  <div>
    <div v-for="(item, index) in dataList[0].children" :key="item.path">
      <!-- <div v-if="item.children?.length > 0" :key="index">
        <el-submenu :index="item.path">
          <template slot="title">

            <img :src="item.meta?.icon" alt="" />
            <span style="margin-left: 5px">{{ item.meta?.title }}</span>
          </template>
          <el-menu-item-group>
            <myitem :data="item.children"></myitem>
          </el-menu-item-group>
        </el-submenu>
      </div> -->
      <!-- 情况二：没子集的情况： -->
      <!-- <div> -->
      <el-menu-item :index="item.path" @click="clickMenu(index)">
        <!-- <i :class="item.meta?.icon"></i> -->
        <img
          v-if="tabIndex == index"
          style="width: 24px; height: 24px"
          :src="require(`@/assets/logistics/${item.meta?.iconActive}.png`)"
          alt=""
        />
        <img
          v-else
          style="width: 24px; height: 24px"
          :src="require(`@/assets/logistics/${item.meta?.icon}.png`)"
          alt=""
        />
        <span style="margin-left: 16px; margin-top: 2px" slot="title">{{
          item.meta?.title
        }}</span>
      </el-menu-item>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "myitem",
  props: ["dataList"],
  data() {
    return {
      tabIndex: '0',
    };
  },
  destroyed() {
  },
  mounted() {
    const index = sessionStorage.getItem("tabIndex");
    if ( index && index > -1) {
      console.log(index, "index");
      
      this.tabIndex = index;
    }
  },
  methods: {
    clickMenu(index) {
      console.log(index, "index");
      this.tabIndex = index;
      sessionStorage.setItem("tabIndex", index);
    },
    // toPath(item) {
    //   this.$router.push(item.path)
    // }
  },
};
</script>
<style lang="scss"></style>
